import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ModalController, Platform} from '@ionic/angular';
import {DocumentModel} from '../../models/document.model';
import {DrawSignaturePage} from '../../modals/draw-signature/draw-signature.page';
import {ScreenOrientation} from '@ionic-native/screen-orientation/ngx';
import { SimpleEngineerBeanModel } from 'src/app/models/simple-engineer-bean.model';

@Component({
    selector: 'simple-signature',
    templateUrl: './simple-signature.component.html',
    styleUrls: ['./simple-signature.component.scss'],
})
export class SimpleSignatureComponent implements OnInit {
    @Input() document: DocumentModel;
    @Input() selectedEngineerObj: SimpleEngineerBeanModel;
    @Input() title: string;

    @Output() simpleEngineerBeanModelChange: EventEmitter<SimpleEngineerBeanModel> = new EventEmitter<SimpleEngineerBeanModel>();

    titleStyle: string = '';

    constructor(private modalController: ModalController,                
        private screenOrientation: ScreenOrientation,
        private plt: Platform,) {
    }

    ngOnInit() {
        if (this.title === 'Engineer Stored Signature') {
           this.titleStyle = 'font-size: large;color: black;'
        }
    }

    async openModalDrawSignature() {
        //if (this.plt.is('cordova')) {
        //    this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.LANDSCAPE);
        //}

        if(!this.document){
            this.document= new DocumentModel();
            this.document.engineerSignature = this.selectedEngineerObj.signature_base64;
        }

        const modal = await this.modalController.create({
            component: DrawSignaturePage,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'document': this.document
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
                if (this.title === 'Signature') {
                    this.document.signature = dataReturned.data;
                }
                if (this.title === 'Engineer Signature') {
                    this.document.engineerSignature = dataReturned.data;
                }
                if (this.title === 'Engineer Stored Signature') {
                    this.selectedEngineerObj.signature_base64 = dataReturned.data;
                    console.log( this.selectedEngineerObj );
                    this.simpleEngineerBeanModelChange.emit( this.selectedEngineerObj );
                }
            }
        });
        return await modal.present();
    }

}
